<template>
  <g>
    <path
      d="M15.05 12.8102L6.56 4.32024C6.17 3.93024 5.54 3.93024 5.15 4.32024L2.32 7.15024C1.93 7.54024 1.93 8.17024 2.32 8.56024L10.81 17.0502C11.2 17.4402 11.83 17.4402 12.22 17.0502L15.05 14.2202C15.44 13.8302 15.44 13.2002 15.05 12.8102Z"
    />
    <path
      d="M14.34 17.7602L17.87 21.2902C18.26 21.6802 18.9 21.6802 19.29 21.2902C19.68 20.9002 19.68 20.2602 19.29 19.8702L15.76 16.3402L14.34 17.7602Z"
    />
    <path
      d="M18.5 9.00024C20.433 9.00024 22 7.43324 22 5.50024C22 3.56725 20.433 2.00024 18.5 2.00024C16.567 2.00024 15 3.56725 15 5.50024C15 7.43324 16.567 9.00024 18.5 9.00024Z"
    />
  </g>
</template>
